export const promoteFeatureToTop = (feature, array) => {
  const featureIndex = array.findIndex((element) => Object.values(element)[0] === feature);
  if (featureIndex >= 0) {
    array.unshift(array.splice(featureIndex, 1)[0]);
  }
  return array;
};

export const filterFeatures = (features, filters) => {
  // Filters out 'sonar_chart_shading'
  let condensedFeatureList = features?.filter((feature) => !!feature && feature !== 'sonar_chart_shading');

  // If both filters are features, only show one
  if (filters[0] && filters[1]) {
    condensedFeatureList = condensedFeatureList.filter((feature) => feature !== 'relief_shading');
  }

  return condensedFeatureList;
};

export const shouldShowCheckmark = (feature, translatedProduct, tableContent) => {
  const isFeatureOfProducts = tableContent[translatedProduct].includes(feature);

  return isFeatureOfProducts;
};
